module.exports = __webpack_public_path__ + "static/media/guest-removed.3be10ec2.svg";